import {type DefaultError, type UseMutationOptions, useMutation} from '@tanstack/react-query'
import type {SuggestObject} from '@yandex-delivery/api/model/suggest'
import {createSuggestRepository} from '@yandex-delivery/api/repo/suggest'
import {createSuggestService} from '@yandex-delivery/api/service/suggest'
import {useMemo} from 'react'

import {useConfigContext} from '../../contexts'
import type {AddressPin, AddressPinParams, SuggestParams} from './model/types'
import {createAddressService} from './services/addressService'
import {useFetch} from './services/fetch'
import {withCountryCode, withExternalApiPrefix} from './utils/fetchWith'

export const useService = () => {
  const {countryCode} = useConfigContext()
  const fetch = useFetch()

  return useMemo(() => {
    const suggestRepository = createSuggestRepository({
      fetch: withCountryCode(countryCode, withExternalApiPrefix(fetch)),
    })

    return createAddressService(createSuggestService(suggestRepository))
  }, [countryCode, fetch])
}

/**
 * Хук для запроса саджеста с адресами.
 */
export const useFetchSuggest = (
  options?: Omit<UseMutationOptions<SuggestObject[], DefaultError, SuggestParams>, 'mutationFn'>,
) => {
  const {fetchSuggest} = useService()

  return useMutation({...options, mutationFn: fetchSuggest})
}

/**
 * Хук для пина адреса.
 */
export const useFetchAddressPin = (
  options?: Omit<UseMutationOptions<AddressPin, DefaultError, AddressPinParams>, 'mutationFn'>,
) => {
  const {fetchAddressPin} = useService()

  return useMutation({...options, mutationFn: fetchAddressPin})
}
